import * as fromDatatype from "../datatype-library/index";

export interface bl_pgw_payment_provider_hdr_RowInterface {
  guid: fromDatatype.GuidDataFieldInterface;
  code: fromDatatype.VarcharDatatypeInterface;
  name: fromDatatype.VarcharDatatypeInterface;
  created_date: fromDatatype.TimestampTzDatatypeInterface;
  updated_date: fromDatatype.TimestampTzDatatypeInterface;
  created_by_subject_guid: fromDatatype.GuidDataFieldInterface;
  updated_by_subject_guid: fromDatatype.GuidDataFieldInterface;
  property_json: fromDatatype.JsonDatatypeInterface;
  description: fromDatatype.TextDatatypeInterface;
  status: fromDatatype.StatusDataFieldInterface;
  revision: fromDatatype.RevisionDataFieldInterface;
  vrsn: fromDatatype.VrsnDataFieldInterface;
  namespace: fromDatatype.VarcharDatatypeInterface;
  category: fromDatatype.VarcharDatatypeInterface;
  max_amount_limit: fromDatatype.BigIntegerDatatypeInterface;
  min_amount_limit: fromDatatype.BigIntegerDatatypeInterface;
  ccy_code: fromDatatype.CurrencyCodeDataFieldInterface;
  country_code: fromDatatype.VarcharDatatypeInterface;
}

export class bl_pgw_payment_provider_hdr_RowClass
  implements bl_pgw_payment_provider_hdr_RowInterface
{
  guid: fromDatatype.GuidDataFieldInterface;
  code: fromDatatype.VarcharDatatypeInterface;
  name: fromDatatype.VarcharDatatypeInterface;
  created_date: fromDatatype.TimestampTzDatatypeInterface;
  updated_date: fromDatatype.TimestampTzDatatypeInterface;
  created_by_subject_guid: fromDatatype.GuidDataFieldInterface;
  updated_by_subject_guid: fromDatatype.GuidDataFieldInterface;
  property_json: fromDatatype.JsonDatatypeInterface;
  description: fromDatatype.TextDatatypeInterface;
  status: fromDatatype.StatusDataFieldInterface;
  revision: fromDatatype.RevisionDataFieldInterface;
  vrsn: fromDatatype.VrsnDataFieldInterface;
  namespace: fromDatatype.VarcharDatatypeInterface;
  category: fromDatatype.VarcharDatatypeInterface;
  max_amount_limit: fromDatatype.BigIntegerDatatypeInterface;
  min_amount_limit: fromDatatype.BigIntegerDatatypeInterface;
  ccy_code: fromDatatype.CurrencyCodeDataFieldInterface;
  country_code: fromDatatype.VarcharDatatypeInterface;
}
